import TemplateView from '../../../TemplateView'
import {onKeyDown, isEsc} from '../../../keyHandlers/index'
import _ from 'underscore'

export default class WordsFilter extends TemplateView {
    constructor({
        onChange = (text) => {
            this.setState({text})
        },
        onHide = () => {
            this.setState({
                open: false,
                text: '',
            })
        },
        onShow = () => {
            this.setState({open: true})
        },
        placeholderClass = '',
    }) {
        super(null)

        this.state = {
            text: '',
            open: false,
            disabled: false,
        }

        this.params = {
            placeholderClass,
            onChange,
            onHide,
            onShow,
        }

        this.onStatePropertyChanged('open', (open, prevOpen) => {
            this.$inputPlaceholder.toggleClass('hidden', !open)
            this.$inputPlaceholder.toggleClass('animShowWordsField', open)
            if (open === true && prevOpen !== open) {
                setTimeout(() => {
                    if (this.state.open)
                        this.$input.focus()
                }, 300)
            }
        })

        this.onStatePropertyChanged('text', () => {
            this.$input.attr('value', this.state.text)
        })

        this.onStatePropertyChanged('disabled', disabled => {
            this.$icon.toggleClass('disabled', disabled)
        })

        this._onChangeThrottled = _.debounce(this.params.onChange, 500)
        this._keyPressHandlerRemover = null
    }

    templateModel() {
        return {
            placeholderClass: this.params.placeholderClass,
        }
    }

    messageKeys() {
        return {
            placeholder: 'userlist.words_filter.start_typing'
        }
    }

    templateHtml() {
        return '<div class="userList_wordsFilter">' +
               '    <div class="icon"></div>' +
               '    <div class="inputPlaceholder <%=placeholderClass%>">' +
               '        <div class="lensIcon"></div>' +
               '        <input type="text" placeholder="<%=placeholder%>"/>' +
               '        <div class="close"></div>' +
               '    </div>' +
               '</div>'
    }

    afterRender() {
        this.$icon = this.find('.icon')
        this.$icon.on('click', this._handleIconClick)
        this.$inputPlaceholder = this.find('.inputPlaceholder')
        this.find('.close').on('click', this._handleCloseClick)
        this.$input = this.find('.inputPlaceholder input')
                          .on('input', this._handleOnInputChange)
                          .on('focus', this._handleOnInputFocus)
                          .on('blur', this._handleOnInputBlur)
        this.renderInitialState()
    }

    _handleIconClick = () => {
        if (this.state.disabled) return

        this.params.onShow()
    }

    _handleCloseClick = () => {
        this.params.onChange('')
        this.params.onHide()
    }

    _handleOnInputFocus = () => {
        this.$inputPlaceholder.addClass('active')
        this._keyPressHandlerRemover = onKeyDown((keyCode) => {
            if (isEsc(keyCode)) {
                this._handleCloseClick()
                return true
            }
        })
    }

    _handleOnInputBlur = () => {
        this.$inputPlaceholder.removeClass('active')
        this._keyPressHandlerRemover()
    }

    _handleOnInputChange = (e) => {
        const text = e.target.value.trim()
        if (text !== this.state.text) {
            this.setStateInternal({text})
            if (this.state.open)
                this._onChangeThrottled(text)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/WordsFilter.js